import { render, staticRenderFns } from "./SFormLaboratoryComp.vue?vue&type=template&id=9a1657f4&"
import script from "./SFormLaboratoryComp.vue?vue&type=script&lang=js&"
export * from "./SFormLaboratoryComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports